module.exports = __webpack_public_path__ + "img/logo.4be1fbe4.png";